export default __webpack_public_path__ + "static/media/sendMoney_root_background.53a45bee.jpg";